import { Injectable } from '@angular/core';

import { DownloadService } from './download.service';
import {
  type FileDownloaderError,
  FileDownloaderService,
} from './file-downloader.service';

@Injectable({
  providedIn: 'root',
})
export class ProxyFileDownloaderService {
  constructor(
    private fileDownloaderService: FileDownloaderService,
    private downloadService: DownloadService,
  ) {}

  download(url: string, fileName: string): void {
    const proxyUrl = 'https://services2.risevision.com/proxy/' + url;

    this.fileDownloaderService
      .download(proxyUrl, '')
      .then((file) => {
        this.downloadService.downloadBlob(file, fileName);
      })
      .catch((error: FileDownloaderError) => {
        this.downloadService.rejectedUploads.push({
          name: fileName,
          rejectedUploadMessage:
            typeof error?.err === 'string' ? error.err : 'Download failed',
        });
        console.error('Failed to download proxied file', error);
      });
  }
}
